export default class Recaptcha {
    // Dodajemy funkcje promise<bool> która będzie wywoływana  w momencie submitowania formularza
    // Funkcja powinna zwracać true jeśli token jest poprawny, false jeśli nie
    verifyToken() {
        return new Promise((resolve, reject) => {
            if (typeof window.__STATE__ === 'undefined') {
                reject('Recaptcha: window.__STATE__ is not defined');
            }
            if (!window.__STATE__?.functions.recaptcha_enabled) {
                resolve(true);
            }
            // Sprawdzamy czy recaptcha jest zainicjalizowana
            if (typeof window.grecaptcha === 'undefined') {
                resolve(true);
            }
            let siteKey = null;
            // Sprawdzamy czy klucz recaptcha jest zdefiniowany w window.__STATE__
            if (typeof window.__STATE__ !== 'undefined' && window.__STATE__.functions.recaptcha_site_key !== null) {
                siteKey = window.__STATE__.functions.recaptcha_site_key;
            }
            if (siteKey === null) {
                resolve(true);
            }
            // Sprawdzamy czy recaptcha jest zainicjalizowana
            window.grecaptcha.ready(() => {
                // Wywołujemy recaptcha.execute w celu pobrania tokenu
                window.grecaptcha
                    .execute(siteKey, { action: 'submit' })
                    .then((token) => {
                    //Wykonujemy request do serwera w celu weryfikacji tokenu
                    fetch(`/api/v1/integrations-googleReCaptcha/recaptcha/verify?token=${token}&action=submit`, {
                        method: 'GET',
                        cache: 'no-cache',
                    })
                        .then((response) => response.json())
                        .then((data) => {
                        resolve(data.result);
                    })
                        .catch((error) => {
                        console.error('Recaptcha: error during token verification', error);
                        reject(error);
                    });
                })
                    .catch((error) => {
                    console.error('Recaptcha: error during token execution', error);
                    reject(error);
                });
            });
        });
    }
}
